import type { CascaderOption } from '@/components';

/**
 * @deprecated
 */
export const getCascaderOptions = <T>(
  data: T[] | null | undefined,
  value: string,
  label: string,
  children: keyof T,
  options?: {
    customLabelRender?: (data: T) => string;
  },
): CascaderOption[] | undefined => {
  return data?.map((d) => {
    if (!d[children]) {
      return {
        value: d[value],
        label: options?.customLabelRender
          ? options.customLabelRender(d)
          : d[label],
        children: [],
      };
    }
    return {
      value: d[value],
      label: options?.customLabelRender
        ? options.customLabelRender(d)
        : d[label],
      children: getCascaderOptions(
        d[children] as T[],
        value,
        label,
        children,
        options,
      ),
    };
  });
};

const getRecursiveOptions = (
  data: CascaderOption[],
  selectedData: string[],
): CascaderOption[] => {
  return data.filter((item) => selectedData.includes(item.value.toString()));
};

const getFlatRecursiveArray = (arr: CascaderOption[]): CascaderOption[] => {
  return arr.reduce((acc: any, item) => {
    acc.push({ ...item, children: [] });
    if (item.children?.length) {
      acc.push(...getFlatRecursiveArray(item.children));
    }
    return acc;
  }, []);
};

export const getSelectedRecursiveOptions = (
  data: CascaderOption[],
  selectedData: string[][],
) => {
  const selectedDataNodes = selectedData.flatMap((item) => item.at(-1) ?? []);
  const flatRecursiveData = getFlatRecursiveArray(data);
  return getRecursiveOptions(flatRecursiveData, selectedDataNodes);
};
